import React from "react";
import Navbar from "../../components/mainNavBar";
import HomeFooter from "../../components/homefooter";
import { Helmet } from "react-helmet";
import { solution } from "../../assets/data/metaData";
import { useNavigate } from "react-router-dom";
import {
  ResearchAcceleration,
  SuperiorSurveyBasedResearch,
  DataDepthAdvantage,
  InsightfulProprietarySegments,
  InteractiveSegmentAvatars,
  IllustrativeResearchApplications,
  GenerativeInsightsMethod,
  TraditionalMethod,
} from "../../assets/data/solutionPages";
export default function SolutionPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{solution.title} </title>
        <meta
          name="description"
          content={solution.description}
          data-rh="true"
        />
        <meta
          name="og:description"
          content={solution.description}
          data-rh="true"
        />
        <meta name="keywords" content={solution.keywords} data-rh="true" />
        <meta property="og:title" content={solution.title} data-rh="true" />
        <meta property="og:image" content={solution.image} data-rh="true" />
        <meta property="og:url" content={solution.url} data-rh="true" />
        <meta
          property="og:publisher"
          content={solution.publisher}
          data-rh="true"
        />
        <meta property="og:author " content={solution.author} data-rh="true" />
        <meta
          property="og:site_name"
          content={solution.site_name}
          data-rh="true"
        />
        <meta property="og:locale" content={solution.locale} data-rh="true" />
        <meta property="og:type" content={solution.type} data-rh="true" />
        <link rel="canonical" href={solution.canonical} data-rh="true" />
      </Helmet>
      <Navbar />
      <main className="pagebg">
        {/* Hero Section */}
        <section className="hero" style={{ paddingTop: "120px" }}>
          <div className="hero-text">
            <h1>Move Beyond Static Research to Ongoing Customer Dialogue</h1>
            <p>
              Insights are dynamic. You need a platform that moves at the speed
              of business, and allows for ongoing, iterative insights on demand
            </p>
          </div>
          <div className="hero-image">
            <img
              className="img-responsive"
              alt="Generative Insight Research"
              src="/json-media/img/SolutionPage/solutionBanner.webp"
            />
          </div>
        </section>
        {/* section 1 */}
        <section className="section features-bottom">
          <h2
            style={{
              textDecoration: "underline",
              textDecorationColor: "#fff",
              fontSize: "2rem",
            }}
          >
            Research Acceleration Benefits
          </h2>

          <div className="features-grid">
            {ResearchAcceleration.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <div className="placeholder icon-placeholder">
                    <img
                      className="img-responsive"
                      alt={item.alt}
                      src={item.img}
                    />
                  </div>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
          <section className="section unlock-insights">
            <div className="unlock-content">
              <div className="unlock-text">
                <div className="hero-buttons">
                  <div>
                    <button
                      className="primary-btn"
                      onClick={() => navigate("/create-survey")}
                    >
                      Try It Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* section 2 */}
        <section className="researcher-tools" style={{ padding: "15PX" }}>
          <h3>Break Free of the Constraints of Traditional Research</h3>
          <p>
             Rigorous market research solutions, delivered at the speed of
            business
          </p>
        </section>
        <section
          className="section features-bottom"
          style={{ padding: "15PX" }}
        >
          <h2
            style={{
              textDecoration: "underline",
              textDecorationColor: "#fff",
              fontSize: "2rem",
            }}
          >
            Superior Survey-Based Research
          </h2>

          <div className="features-grid">
            {SuperiorSurveyBasedResearch.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <div className="placeholder icon-placeholder">
                    <img
                      className="img-responsive"
                      alt={item.alt}
                      src={item.img}
                    />
                  </div>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
          <section className="section unlock-insights">
            <div className="unlock-content">
              <div className="unlock-text">
                <div className="hero-buttons">
                  <div>
                    <button
                      className="primary-btn"
                      onClick={() => navigate("/create-survey")}
                    >
                      Accelerate Your Research Today
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* section 3 */}
        <section className="researcher-tools" style={{ padding: "15PX" }}>
          <h3>Beyond Self-Reported Data for Every Respondent</h3>
          <p>
            Deep data across millions of respondent profiles enable robust
            analysis of every segment, as well as targeting logic for future
            marketing outreach
          </p>
        </section>
        <section
          className="section features-bottom"
          style={{ padding: "15PX" }}
        >
          <h2
            style={{
              textDecoration: "underline",
              textDecorationColor: "#fff",
              fontSize: "2rem",
            }}
          >
            Data Depth Advantage
          </h2>

          <div className="features-grid">
            {DataDepthAdvantage.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <div className="placeholder icon-placeholder">
                    <img
                      className="img-responsive"
                      alt={item.alt}
                      src={item.img}
                    />
                  </div>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
          <section className="section unlock-insights">
            <div className="unlock-content">
              <div className="unlock-text">
                <div className="hero-buttons">
                  <div>
                    <button
                      className="primary-btn"
                      onClick={() => navigate("/create-survey")}
                    >
                      Get Started
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* section 4 */}
        <section className="researcher-tools" style={{ padding: "15PX" }}>
          <h3>Customer Understanding through Proprietary Segmentation</h3>
          <p>
            Discover customer segments with unprecedented depth, powered by
            comprehensive data profiles and rich survey-based insights
          </p>
        </section>
        <section
          className="section features-bottom"
          style={{ padding: "15PX" }}
        >
          <h2
            style={{
              textDecoration: "underline",
              textDecorationColor: "#fff",
              fontSize: "2rem",
            }}
          >
            Insightful Proprietary Segments
          </h2>

          <div className="features-grid">
            {InsightfulProprietarySegments.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <div className="placeholder icon-placeholder">
                    <img
                      className="img-responsive"
                      alt={item.alt}
                      src={item.img}
                    />
                  </div>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
          <section className="section unlock-insights">
            <div className="unlock-content">
              <div className="unlock-text">
                <div className="hero-buttons">
                  <div>
                    <button
                      className="primary-btn"
                      onClick={() => navigate("/create-survey")}
                    >
                      Create Your Proprietary Segments
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* section 5 */}
        <section className="researcher-tools" style={{ padding: "15PX" }}>
          <h3>From Static Reports to Living Customer Intelligence</h3>
          <p>
            Empower your organization with realtime customer feedback on any
            topic
          </p>
        </section>
        <section
          className="section features-bottom"
          style={{ padding: "15PX" }}
        >
          <h2
            style={{
              textDecoration: "underline",
              textDecorationColor: "#fff",
              fontSize: "2rem",
            }}
          >
            Interactive Segment Avatars
          </h2>

          <div className="features-grid">
            {InteractiveSegmentAvatars.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <div className="placeholder icon-placeholder">
                    <img
                      className="img-responsive"
                      alt={item.alt}
                      src={item.img}
                    />
                  </div>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
          <section className="section unlock-insights">
            <div className="unlock-content">
              <div className="unlock-text">
                <div className="hero-buttons">
                  <div>
                    <button
                      className="primary-btn"
                      onClick={() => navigate("/create-survey")}
                    >
                      Voice of the Customer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* section 6 */}
        <section className="researcher-tools" style={{ padding: "15PX" }}>
          <h3>Broad Applicability Across Use Cases</h3>
          <p>
            The fastest way to deliver rigorous research spanning a wide range
            of research use cases
          </p>
        </section>
        <section
          className="section features-bottom"
          style={{ padding: "15PX" }}
        >
          <h2
            style={{
              textDecoration: "underline",
              textDecorationColor: "#fff",
              fontSize: "2rem",
            }}
          >
            Illustrative Research Applications
          </h2>

          <div className="features-grid">
            {IllustrativeResearchApplications.map((item, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">
                  <div className="placeholder icon-placeholder">
                    <img
                      className="img-responsive"
                      alt={item.alt}
                      src={item.img}
                    />
                  </div>
                </div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
          <section className="section unlock-insights">
            <div className="unlock-content">
              <div className="unlock-text">
                <div className="hero-buttons">
                  <div>
                    <button
                      className="primary-btn"
                      onClick={() => navigate("/create-survey")}
                    >
                      Start Your Research Project
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* section 7 */}
        <section className="researcher-tools" style={{ padding: "15PX" }}>
          <h3>Complement Traditional Methods with AI Acceleration</h3>
          <p>
            Every research team needs tools for different situations—AI excels
            when unlimited questioning and ongoing dialogue are needed
          </p>
          <div className="solution-feature-wrapper">
            {/* SHARED HEADING BOX */}
            <div className="solution-header-row">
              <div>
                <h2>When to Use Generative Insight</h2>
              </div>
              <div>
                <h2>When to Use Traditional Methods</h2>
              </div>
            </div>

            {/* SHARED CONTENT BOX */}
            <div className="solution-body-row">
              {/* LEFT CONTENT */}
              <div className="solution-column">
                {GenerativeInsightsMethod.map((item, index) => (
                  <div className="solution-item" key={index}>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                ))}
              </div>

              {/* RIGHT CONTENT */}
              <div className="solution-column">
                {TraditionalMethod.map((item, index) => (
                  <div className="solution-item" key={index}>
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        {/* section 8 */}
        <section className="section unlock-insights insights-solution ">
          <section className="researcher-tools" style={{ padding: "15PX" }}>
            <h3>Ready to Add AI to Your Research Toolkit?</h3>
            <p>
              Partner with Al to accelerate your research. Book a live demo or
              start your project instantly.
            </p>
          </section>
          <div className="unlock-content">
            <div className="unlock-text">
              <div className="hero-buttons">
                <div>
                  <button
                    className="primary-btn"
                    onClick={() => navigate("/create-survey")}
                  >
                    Start Your First Project
                  </button>
                </div>
                {/* <div>
                  <button className="secondary-btn">
                    View Sample Deliverables
                  </button>
                </div> */}
              </div>
              <br />
            </div>
          </div>
        </section>
        <br />
      </main>
      <HomeFooter />
    </>
  );
}
